import { de } from './pathnames.de';
import { en } from './pathnames.en';
import { es } from './pathnames.es';
import { fr } from './pathnames.fr';
import { it } from './pathnames.it';

const defaultLocale = en;

export const PATHNAMES = {
  default: defaultLocale,
  de,
  en,
  es,
  fr,
  it,
  // Add more locales here
  pt: defaultLocale,
  nl: defaultLocale,
  ru: defaultLocale,
  ja: defaultLocale,
  zh: defaultLocale,
  ko: defaultLocale,
  sv: defaultLocale,
  no: defaultLocale,
  fi: defaultLocale,
  da: defaultLocale,
  pl: defaultLocale,
  tr: defaultLocale,
  cs: defaultLocale,
  hu: defaultLocale,
  sk: defaultLocale,
  ro: defaultLocale,
  el: defaultLocale,
  hr: defaultLocale,
  bg: defaultLocale,
  uk: defaultLocale,
  th: defaultLocale,
  vi: defaultLocale,
  id: defaultLocale,
  ms: defaultLocale,
  ml: defaultLocale,
  ta: defaultLocale,
  hi: defaultLocale,
  bn: defaultLocale,
  ne: defaultLocale,
  si: defaultLocale,
  km: defaultLocale,
  lo: defaultLocale,
  my: defaultLocale,
  mr: defaultLocale,
  pa: defaultLocale,
  gu: defaultLocale,
  or: defaultLocale,
  te: defaultLocale,
  kn: defaultLocale,
  as: defaultLocale,
  cy: defaultLocale,
  sq: defaultLocale,
  he: defaultLocale,
} as const;
